<template>
  <BaseItem
      ref="RefItem"
      :item-uid="itemUid"
      parentComponent="HistoryTable"
      :lock-page="lockPage"
      :dto-detail-model="dto_detail_model"
      :dto-save-model="dto_save_model"
      :dto_validate_model="dto_validate_model"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      :height="height"
      :width="width"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight}">
    </template>
  </BaseItem>
</template>

<script>
import ConfirmDialog from "@/components/Base/ConfirmDialog";
// import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";
import TipTapEditor from "@/components/TipTap/TipTapEditor";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";


export default {
  name: 'HistoryItem',
  props: {
    itemUid: {default: null},
    dto_detail_model: {type: [String], default: 'HistoryDetailQueryDTO'},
    dto_save_model: {type: [String], default: 'HistorySaveCommandDTO'},
    dto_validate_model: {type: [String], default: null},
    store_name: {type: [String], default: 'HistoryTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    height: {default: null},
    width: {default: null},
  },

  components: {
    BaseDeleteIcon,
    ConfirmDialog,
    BaseItem,
  },

  computed: {},

  methods: {
    onClose(event) {
      console.log('unload', event);
      if (this.$refs.RefItem.countBackup > 0) {
        event.returnValue = 'Do you really want to leave? you have unsaved changes!'
        return event.returnValue
      }
      return true
    },
    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },
  },

  async mounted() {
    window.addEventListener('beforeunload', this.onClose)
  }
  ,

  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave')
    if (this.$refs.RefItem.countBackup === 0)
      next()
    else {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer)
        next()
      else
        next(false)
    }
  },

  data() {
    return {
      file: null,
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "columns": {}
  },
  "de": {
    "columns": {}
  }
}
</i18n>
